import styled from "styled-components";
import Markdown from "./Docs/Markdown";

const StyledMarkdown = styled(Markdown)`
  padding: 10px 35px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;

  h1,
  h2,
  h3,
  h4,
  h5 {
    border-bottom: 1px solid #bbc3df;
    padding-bottom: 10px;
  }

  h1 {
    font-size: 24px;
    font-weight: 600;
  }

  h2 {
    font-size: 20px;
    font-weight: 600;
  }

  h3 {
    font-size: 18px;
    font-weight: 400;
  }
`;

export default StyledMarkdown;
